import React from 'react';
import './Loader.css';

const Loader = ({ text = "Veriler Yükleniyor..." }) => {
  return (
    <div className="premium-loader-container">
      <div className="bigma-spin">BIGMA</div>
      <span>{text}</span>
    </div>
  );
};

export default Loader;